export default __webpack_public_path__ + "static/media/prod-detail-media-template.c15ac64d.svg";